import React, { memo } from "react";

import { LiveMissionsTable } from "Components/LiveMissionsTable/LiveMissionsTable";

export const LiveMissionsPage = memo(() => {
  return <LiveMissionsTable />;
});
